import { useGeneratePath } from '../../../../hooks/useGeneratePath';

export const useDetailsPath = (id?: number) =>
  useGeneratePath({
    id,
    page: 'products',
    option: 'details',
  });
